module.exports = __webpack_public_path__ + "img/m1-screenshot-10.9252f253.png";